import React from 'react';

import cx from 'classnames';

import { Image } from 'react-bootstrap';

import smartGatingIcon from "../../../../../assets/images/smartGatingBorder.svg"

import styles from './sparkle.module.scss';

export const Sparkle = ({
    width,
    height
  }) => {
    return (
      <div className={cx(styles.sparkleWrapper)} style={{
        width,
        height
      }}>
        <Image
          className={styles.pulseImage}
          src={smartGatingIcon}
          width={width || 20}
          height={height || 20}
        />
        <Image
          className={styles.pulseImage2}
          src={smartGatingIcon}
          width={width || 20}
          height={height || 20}
        />
      </div>
    );
  };